export default "__VITE_ASSET__CCQM5shh__"